<div class="discriptive-type-container">
  <div class="main-dev" *ngIf="display && !isListMode">
    <div class="btn-wrapper descriptive-main">
      <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
        <span>{{'questions.typeOfQuestions.surveyShortAns.btnBack' | translate}}</span>
      </button>
      <span class="spacer"></span>
      <button [disabled]="surveyShortAnswerForm.invalid" mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()'>
        <span>{{'questions.typeOfQuestions.surveyShortAns.btnSave' | translate}}</span>
      </button>
    </div>

    <form [formGroup]="surveyShortAnswerForm">
      <ng-container>
        <div class="filter-section">
          <div class="body-section title">
            <mat-icon>library_add</mat-icon> &nbsp;
            <span>{{'questions.typeOfQuestions.surveyShortAns.title' | translate}}</span>
          </div>
          <div class="body-section-2" formGroupName="questiondescription">
            <label class="que-label">{{'questions.typeOfQuestions.surveyShortAns.labelQuest' | translate}}</label>
            <ckeditor #myEditor formControlName="description" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
            <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <!-- <ckeditor formControlName="description" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
          </div>
        </div>
      </ng-container>
      <div class="input2">
        <div class="seqInput">
          <label class="Questions-score">{{'questions.typeOfQuestions.surveyShortAns.labelCharLimit' | translate}}<span class="error">*</span></label>
          <input min="0" class="form-control" type="number" onkeyup="if(this.value.length == 6 ) return false;" max="32000"
            formControlName="maximumcharacterForFreetext" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
          <mat-error *ngIf="this.surveyShortAnswerForm.controls['maximumcharacterForFreetext'].value >= 32001">{{'questions.typeOfQuestions.surveyShortAns.charLimitError1' | translate}}</mat-error>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="!display">
    <app-choose-question-type></app-choose-question-type>
  </div>

  <div *ngIf="isListMode">
    <app-question-list></app-question-list>
  </div>
</div>
